/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classnames = require("classnames");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./Lookup.css'); }
var moduleClassNameFactory_1 = require("./util/moduleClassNameFactory");
var Input_1 = require("./Input");
var Button_1 = require("./Button");
var KeyDown_1 = require("./util/KeyDown");
var moduleClassName = moduleClassNameFactory_1.moduleClassNameFactory("m-lookup");
var ENTER_KEY_CODE = 13;
var Lookup = /** @class */ (function (_super) {
    tslib_1.__extends(Lookup, _super);
    function Lookup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onLookup = function (e) {
            var _a = _this.props, onLookup = _a.onLookup, value = _a.value;
            if (onLookup && value) {
                onLookup(e);
            }
        };
        return _this;
    }
    Lookup.prototype.render = function () {
        var _a = this.props, id = _a.id, name = _a.name, disabled = _a.disabled, waiting = _a.waiting, hasWarning = _a.hasWarning, value = _a.value, inputLabel = _a.inputLabel, buttonLabel = _a.buttonLabel, errorMessage = _a.errorMessage, almostActive = _a.almostActive, onLookup = _a.onLookup, onChange = _a.onChange, onBlur = _a.onBlur, onFocus = _a.onFocus;
        return (React.createElement("div", { className: classnames(moduleClassName(), this.props.className) },
            React.createElement(KeyDown_1.KeyDown, { keyCodes: [ENTER_KEY_CODE], onKeyDown: this.onLookup },
                React.createElement(Input_1.Input, { id: id, name: name, type: "text", iconLeftType: "search", label: inputLabel, value: value, hasWarning: hasWarning, onBlur: onBlur, onFocus: onFocus, onChange: onChange, errorMessage: errorMessage, readOnly: waiting })),
            React.createElement(Button_1.Button, { disabled: disabled, waiting: waiting, onClick: onLookup, almostActive: almostActive }, buttonLabel)));
    };
    return Lookup;
}(React.Component));
exports.Lookup = Lookup;